import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, type TableColumnsType } from 'antd';
import { PosTable } from 'pos-client/components/shared/Display/Table/PosTable.tsx';
import { useFilters } from 'pos-client/hooks/useFilters.tsx';
import { useTableData } from 'pos-client/hooks/useTableData.ts';
import { trpc } from 'pos-client/utils/trpc.ts';
import type {
  OpeningHoursGroupModel,
  OpeningHoursListFilterModel,
} from 'pos-shared/models/openingHoursGroupSchema.ts';

export const HoursGroups = () => {
  const { t } = useTranslation();

  const { formFilters, onPageChange } = useFilters<OpeningHoursListFilterModel>(
    {
      sortAscending: true,
      orderBy: 'Name',
      pageNumber: 1,
      resultsPerPage: 10,
    }
  );

  const { data: groupsData, isLoading } =
    trpc.getAllOpeningHoursGroups.useQuery(formFilters);

  const data = useTableData(groupsData?.results, (x) => x.id);

  const columns: TableColumnsType<OpeningHoursGroupModel> = [
    {
      title: t('common.contact.name'),
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: t('common.words.code'),
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: '',
      dataIndex: 'id',
      width: 10,
      render: (id) => (
        <Link to={`/opening-hours/${id}/defaultSchedule`}>
          <Button size="small">{t('common.buttons.view')}</Button>
        </Link>
      ),
    },
  ];

  return (
    <>
      <PosTable
        id="openingHours"
        dataSource={data}
        columns={columns}
        isLoading={isLoading}
        padding={0}
        paging={{
          current: formFilters.pageNumber,
          pageSize: formFilters.resultsPerPage,
          total: groupsData?.totalResults,
          onChange: (page, pageSize) => {
            onPageChange(page, pageSize);
          },
        }}
      />
    </>
  );
};
